export var GET_USER_TOKEN = 'GET_USER_TOKEN';
export var GET_FAVORITE_SPOTS = 'GET_FAVORITE_SPOTS';
export var CREATE_FAVORITE_SPOT = 'CREATE_FAVORITE_SPOT';
export var DELETE_FAVORITE_SPOT = 'DELETE_FAVORITE_SPOT';
export var SAVE_FAVORITE_SPOT_ID = 'SAVE_FAVORITE_SPOT_ID';
export var SET_API_PARAMS = 'SET_API_PARAMS';
export var AUTH_WINDOW = 'AUTH_WINDOW';